export const FULL_WIDTH = true;
